import { c as _c } from "react/compiler-runtime";
import { isVaultDataEmpty } from '@onefootprint/core';
import type { InvestorProfileDeclaration, InvestorProfileInvestmentGoal } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';
import { FieldOrPlaceholder } from '@/components';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useAutoDecryptControls from '@/entity/hooks/use-auto-decrypt-controls';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import createStringList, { createCapitalStringList } from '@/utils/create-string-list';
import Field from '../../../field';
import FieldSection from './components/field-section';
import FinraField from './components/finra-field';
type InvestorProfileFieldsProps = WithEntityProps;
const InvestorProfileFields = t0 => {
  const $ = _c(126);
  const {
    entity
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.user.vault.investorProfile"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== entity.data || $[2] !== entity.id) {
    t2 = {
      entityAttributes: entity.data,
      entityId: entity.id
    };
    $[1] = entity.data;
    $[2] = entity.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data
  } = useEntityVault(t2);
  const vaultData = data?.vault;
  const autoDecryptControls = useAutoDecryptControls(entity.kind);
  const decryptControls = useDecryptControls();
  let t3;
  if ($[4] !== autoDecryptControls || $[5] !== decryptControls || $[6] !== entity.data || $[7] !== entity.id) {
    const investorProfileDis = entity.data.map(_temp).filter(_temp2);
    t3 = autoDecryptControls.isEntityAutoDecrypting(entity.id) && decryptControls.isDecrypting(investorProfileDis);
    $[4] = autoDecryptControls;
    $[5] = decryptControls;
    $[6] = entity.data;
    $[7] = entity.id;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isAutoDecrypting = t3;
  let t4;
  if ($[9] !== t) {
    t4 = t(_temp3);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isAutoDecrypting || $[12] !== t) {
    t5 = (value, isValueDecrypted) => isValueDecrypted ? <FieldOrPlaceholder data={t($_0 => $_0.employmentStatus.options[value])} /> : <FieldOrPlaceholder data={value} isLoading={isAutoDecrypting} />;
    $[11] = isAutoDecrypting;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== entity || $[15] !== t5) {
    t6 = <Field di="investor_profile.employment_status" entity={entity} renderValue={t5} />;
    $[14] = entity;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t4 || $[18] !== t6) {
    t7 = <FieldSection title={t4}>{t6}</FieldSection>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = t(_temp4);
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t10;
  let t9;
  if ($[22] !== entity) {
    t9 = <Field di="investor_profile.occupation" entity={entity} />;
    t10 = <Field di="investor_profile.employer" entity={entity} />;
    $[22] = entity;
    $[23] = t10;
    $[24] = t9;
  } else {
    t10 = $[23];
    t9 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
    t11 = <FieldSection title={t8}>{t9}{t10}</FieldSection>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t(_temp5);
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isAutoDecrypting || $[32] !== t) {
    t13 = (value_0, isValueDecrypted_0) => isValueDecrypted_0 ? <FieldOrPlaceholder data={t($_3 => $_3.annualIncome.options[value_0])} /> : <FieldOrPlaceholder data={value_0} isLoading={isAutoDecrypting} />;
    $[31] = isAutoDecrypting;
    $[32] = t;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== entity || $[35] !== t13) {
    t14 = <Field di="investor_profile.annual_income" entity={entity} renderValue={t13} />;
    $[34] = entity;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t12 || $[38] !== t14) {
    t15 = <FieldSection title={t12}>{t14}</FieldSection>;
    $[37] = t12;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = t(_temp6);
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== isAutoDecrypting || $[43] !== t) {
    t17 = (value_1, isValueDecrypted_1) => isValueDecrypted_1 ? <FieldOrPlaceholder data={t($_5 => $_5.netWorth.options[value_1])} /> : <FieldOrPlaceholder data={value_1} isLoading={isAutoDecrypting} />;
    $[42] = isAutoDecrypting;
    $[43] = t;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== entity || $[46] !== t17) {
    t18 = <Field di="investor_profile.net_worth" entity={entity} renderValue={t17} />;
    $[45] = entity;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t16 || $[49] !== t18) {
    t19 = <FieldSection title={t16}>{t18}</FieldSection>;
    $[48] = t16;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t11 || $[52] !== t15 || $[53] !== t19 || $[54] !== t7) {
    t20 = <div className="flex flex-col gap-3 flex-1">{t7}{t11}{t15}{t19}</div>;
    $[51] = t11;
    $[52] = t15;
    $[53] = t19;
    $[54] = t7;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="hidden @3xl:block w-px border-l border-solid border-tertiary mx-6" />;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== entity || $[58] !== isAutoDecrypting || $[59] !== t || $[60] !== vaultData) {
    t22 = isVaultDataEmpty(vaultData?.["investor_profile.funding_sources"]) ? null : <FieldSection title={t(_temp7)}><Field di="investor_profile.funding_sources" entity={entity} renderValue={value_2 => {
        if (Array.isArray(value_2)) {
          return <FieldOrPlaceholder data={createCapitalStringList(value_2.map(option => t($_7 => $_7.fundingSources.options[option])))} isLoading={isAutoDecrypting} />;
        }
        return <FieldOrPlaceholder data={value_2} isLoading={isAutoDecrypting} />;
      }} /></FieldSection>;
    $[57] = entity;
    $[58] = isAutoDecrypting;
    $[59] = t;
    $[60] = vaultData;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t) {
    t23 = t(_temp8);
    $[62] = t;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== isAutoDecrypting || $[65] !== t) {
    t24 = value_3 => {
      if (Array.isArray(value_3)) {
        return <FieldOrPlaceholder data={createCapitalStringList(value_3.map(option_0 => t($_9 => $_9.investmentGoals.options[option_0 as InvestorProfileInvestmentGoal])))} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_3} isLoading={isAutoDecrypting} />;
    };
    $[64] = isAutoDecrypting;
    $[65] = t;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== entity || $[68] !== t24) {
    t25 = <Field di="investor_profile.investment_goals" entity={entity} renderValue={t24} />;
    $[67] = entity;
    $[68] = t24;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  let t26;
  if ($[70] !== t23 || $[71] !== t25) {
    t26 = <FieldSection title={t23}>{t25}</FieldSection>;
    $[70] = t23;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] !== t) {
    t27 = t(_temp9);
    $[73] = t;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] !== isAutoDecrypting || $[76] !== t) {
    t28 = (value_4, isValueDecrypted_2) => isValueDecrypted_2 ? <FieldOrPlaceholder data={t($_11 => $_11.riskTolerance.options[value_4])} isLoading={isAutoDecrypting} /> : <FieldOrPlaceholder data={value_4} isLoading={isAutoDecrypting} />;
    $[75] = isAutoDecrypting;
    $[76] = t;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  let t29;
  if ($[78] !== entity || $[79] !== t28) {
    t29 = <Field di="investor_profile.risk_tolerance" entity={entity} renderValue={t28} />;
    $[78] = entity;
    $[79] = t28;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  let t30;
  if ($[81] !== t27 || $[82] !== t29) {
    t30 = <FieldSection title={t27}>{t29}</FieldSection>;
    $[81] = t27;
    $[82] = t29;
    $[83] = t30;
  } else {
    t30 = $[83];
  }
  let t31;
  if ($[84] !== t) {
    t31 = t(_temp10);
    $[84] = t;
    $[85] = t31;
  } else {
    t31 = $[85];
  }
  let t32;
  if ($[86] !== isAutoDecrypting || $[87] !== t) {
    t32 = value_5 => {
      if (Array.isArray(value_5)) {
        if (value_5.length === 0) {
          return <FieldOrPlaceholder data={t(_temp11)} isLoading={isAutoDecrypting} />;
        }
        return <FieldOrPlaceholder data={createCapitalStringList(value_5.map(option_1 => t($_14 => $_14.declarations.options[option_1 as InvestorProfileDeclaration])))} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_5} isLoading={isAutoDecrypting} />;
    };
    $[86] = isAutoDecrypting;
    $[87] = t;
    $[88] = t32;
  } else {
    t32 = $[88];
  }
  let t33;
  if ($[89] !== entity || $[90] !== t32) {
    t33 = <Field di="investor_profile.declarations" entity={entity} renderValue={t32} />;
    $[89] = entity;
    $[90] = t32;
    $[91] = t33;
  } else {
    t33 = $[91];
  }
  let t34;
  if ($[92] !== entity || $[93] !== vaultData) {
    t34 = isVaultDataEmpty(vaultData?.["investor_profile.brokerage_firm_employer"]) ? null : <Field di="investor_profile.brokerage_firm_employer" entity={entity} />;
    $[92] = entity;
    $[93] = vaultData;
    $[94] = t34;
  } else {
    t34 = $[94];
  }
  let t35;
  if ($[95] !== entity || $[96] !== isAutoDecrypting || $[97] !== vaultData) {
    t35 = isVaultDataEmpty(vaultData?.["investor_profile.senior_executive_symbols"]) ? null : <Field di="investor_profile.senior_executive_symbols" entity={entity} renderValue={value_6 => {
      if (Array.isArray(value_6)) {
        return <FieldOrPlaceholder data={createStringList(value_6 as string[])} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_6} isLoading={isAutoDecrypting} />;
    }} />;
    $[95] = entity;
    $[96] = isAutoDecrypting;
    $[97] = vaultData;
    $[98] = t35;
  } else {
    t35 = $[98];
  }
  let t36;
  if ($[99] !== entity || $[100] !== isAutoDecrypting || $[101] !== vaultData) {
    t36 = isVaultDataEmpty(vaultData?.["investor_profile.family_member_names"]) ? null : <Field di="investor_profile.family_member_names" entity={entity} renderValue={value_7 => {
      if (Array.isArray(value_7)) {
        return <FieldOrPlaceholder data={createStringList(value_7 as string[])} isLoading={isAutoDecrypting} />;
      }
      return <FieldOrPlaceholder data={value_7} isLoading={isAutoDecrypting} />;
    }} />;
    $[99] = entity;
    $[100] = isAutoDecrypting;
    $[101] = vaultData;
    $[102] = t36;
  } else {
    t36 = $[102];
  }
  let t37;
  if ($[103] !== entity || $[104] !== vaultData) {
    t37 = isVaultDataEmpty(vaultData?.["investor_profile.political_organization"]) ? null : <Field di="investor_profile.political_organization" entity={entity} />;
    $[103] = entity;
    $[104] = vaultData;
    $[105] = t37;
  } else {
    t37 = $[105];
  }
  let t38;
  if ($[106] !== entity || $[107] !== isAutoDecrypting || $[108] !== vaultData) {
    t38 = isVaultDataEmpty(vaultData?.["document.finra_compliance_letter"]) ? null : <Field di="document.finra_compliance_letter" entity={entity} renderValue={(value_8, isValueDecrypted_3) => isValueDecrypted_3 ? <FinraField base64Data={value_8 as string} /> : <FieldOrPlaceholder data={value_8} isLoading={isAutoDecrypting} />} />;
    $[106] = entity;
    $[107] = isAutoDecrypting;
    $[108] = vaultData;
    $[109] = t38;
  } else {
    t38 = $[109];
  }
  let t39;
  if ($[110] !== t31 || $[111] !== t33 || $[112] !== t34 || $[113] !== t35 || $[114] !== t36 || $[115] !== t37 || $[116] !== t38) {
    t39 = <FieldSection title={t31}>{t33}{t34}{t35}{t36}{t37}{t38}</FieldSection>;
    $[110] = t31;
    $[111] = t33;
    $[112] = t34;
    $[113] = t35;
    $[114] = t36;
    $[115] = t37;
    $[116] = t38;
    $[117] = t39;
  } else {
    t39 = $[117];
  }
  let t40;
  if ($[118] !== t22 || $[119] !== t26 || $[120] !== t30 || $[121] !== t39) {
    t40 = <div className="flex flex-col gap-3 flex-1">{t22}{t26}{t30}{t39}</div>;
    $[118] = t22;
    $[119] = t26;
    $[120] = t30;
    $[121] = t39;
    $[122] = t40;
  } else {
    t40 = $[122];
  }
  let t41;
  if ($[123] !== t20 || $[124] !== t40) {
    t41 = <div className="flex flex-col gap-6 @3xl:flex-row @3xl:gap-0">{t20}{t21}{t40}</div>;
    $[123] = t20;
    $[124] = t40;
    $[125] = t41;
  } else {
    t41 = $[125];
  }
  return t41;
};
export default InvestorProfileFields;
function _temp(t0) {
  const {
    identifier
  } = t0;
  return identifier;
}
function _temp2(identifier_0) {
  return identifier_0.startsWith("investor_profile");
}
function _temp3($) {
  return $.employmentStatus.title;
}
function _temp4($_1) {
  return $_1.occupation.title;
}
function _temp5($_2) {
  return $_2.annualIncome.title;
}
function _temp6($_4) {
  return $_4.netWorth.title;
}
function _temp7($_6) {
  return $_6.fundingSources.title;
}
function _temp8($_8) {
  return $_8.investmentGoals.title;
}
function _temp9($_10) {
  return $_10.riskTolerance.title;
}
function _temp10($_12) {
  return $_12.declarations.title;
}
function _temp11($_13) {
  return $_13.declarations.options.none;
}